module.exports = __webpack_public_path__ + "img/icon7.a3af2bd.png";